module.exports = "/static-assets/_next/static/images/img-a15b8337ea-3d615d868ce635e344d9ada36c9ee6da.webp";